<template>
    <pre-datetimepicker
        v-bind="$attrs"
        date-format="H:i:S"
        :display-date-format="displayDateFormat"
        :input-class-name="className"
        :locale="$i18n.locale"
        :no-calendar="true"
        :twelve-hour-time="twelveHourTime"
        v-on="$listeners"
    />
</template>

<script>
    import { PreDatetimepicker } from 'pre-ui';

    export default {
        components: { PreDatetimepicker },

        props: {
            className: {
                type: String,
                default: 'form-input',
            },
        },

        computed: {
            twelveHourTime() {
                return this.$i18n.locale === 'en';
            },

            displayDateFormat() {
                return this.twelveHourTime ? 'h:i K' : 'H:i';
            },
        },
    };
</script>
